// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CommonDelete2 #DialogContent{padding-top:0}.CommonDelete2 #DialogContent .contet-close-button{left:23px;position:relative}.CommonDelete2 #DialogContent #title{color:var(--primary);font-size:16px;font-weight:600;margin:0;text-align:center}.CommonDelete2 #DialogContent #body{color:#6a6a6a;font-size:12px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
